import React from "react";
import styles from "./ViewShortcuts.module.css";
import ModalView from "@modals/modalview/ModalView";

function ViewShortcuts({
    isOpen,
    onClose,
}: {
    isOpen: boolean;
    onClose: () => void;
}) {
    return (
        <ModalView isOpen={isOpen} onClose={onClose} >
            <div className={styles.container}>
                <div className={styles.header}>
                    <h2 className={styles.title}>{"Shortcuts"}</h2>
                    <button className={styles.closeBtn} onClick={onClose}>
                        &times;
                    </button>
                </div>
                <div className={styles.content}>
                    <table className={styles.shortcutTable}>
                        <thead>
                            <tr>
                                <th>Action</th>
                                <th>Shortcut</th>
                            </tr>
                        </thead>
                        <tbody>
                            {/* Panel & Tab Navigation */}
                            <tr>
                                <td>Open View Shortcuts</td>
                                <td>Alt + /</td>
                            </tr>
                            <tr>
                                <td>Hint Mode</td>
                                <td>Shift + ?</td>
                            </tr>
                            <tr>
                                <td>Close Hint Mode</td>
                                <td>Esc</td>
                            </tr>
                            <tr>
                                <td>Toggle Question Panel</td>
                                <td>Alt + 1</td>
                            </tr>
                            <tr>
                                <td>Toggle Rubric Panel</td>
                                <td>Alt + 2</td>
                            </tr>
                            <tr>
                                <td>Toggle Solution Panel</td>
                                <td>Alt + 3</td>
                            </tr>
                            <tr>
                                <td>Toggle All Panels</td>
                                <td>Alt + \</td>
                            </tr>

                            {/* Evaluation & Grading */}
                            <tr>
                                <td>Accept L1 / AI Evaluation</td>
                                <td>Alt + A</td>
                            </tr>
                            <tr>
                                <td>Override Evaluation</td>
                                <td>Alt + O</td>
                            </tr>
                            <tr>
                                <td>Focus Marks Field (Override)</td>
                                <td>Alt + M</td>
                            </tr>
                            <tr>
                                <td>Focus Remarks Field (Override)</td>
                                <td>Alt + R</td>
                            </tr>
                            <tr>
                                <td>Open / Focus Verdict Dropdown</td>
                                <td>Alt + V</td>
                            </tr>
                            <tr>
                                <td>Close Override / Modal (No Save)</td>
                                <td>Esc</td>
                            </tr>

                            {/* Item Navigation */}
                            <tr>
                                <td>Next Question</td>
                                <td>Alt + →</td>
                            </tr>
                            <tr>
                                <td>Previous Question</td>
                                <td>Alt + ←</td>
                            </tr>

                            {/* Submission & Confirmation */}
                            <tr>
                                <td>Approve & Next / Submit</td>
                                <td>Ctrl + Enter</td>
                            </tr>
                            <tr>
                                <td>Confirm Dialog Action</td>
                                <td>Enter</td>
                            </tr>
                            <tr>
                                <td>Cancel Dialog Action</td>
                                <td>Esc</td>
                            </tr>

                            {/* Viewport Controls */}
                            <tr>
                                <td>Zoom In (Student Answer View)</td>
                                <td>+</td>
                            </tr>
                            <tr>
                                <td>Zoom Out (Student Answer View)</td>
                                <td>-</td>
                            </tr>
                        </tbody>

                    </table>
                </div>
            </div>
        </ModalView>
    );
}

export default ViewShortcuts;
